// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"styles_pageTitle__3pzz4","patientInfo":"styles_patientInfo__3guVp"};